var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconSelect',_vm._g({attrs:{"value":_vm.value,"options":_vm.shapes,"src":(shape) => require(`~/assets/images/icons/${shape.icon}`),"placeholder":_vm.$t('editor.shape.placeholder'),"small":"","append-to":_vm.appendTo}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }